module.exports = __webpack_public_path__ + "141d4a85/img/at-icon.5d6fc5d8.svg";